// import { useState, useEffect } from 'react'
import Head from 'next/head'
// import dynamic from 'next/dynamic'
import { MailOutlined, PhoneOutlined } from '@ant-design/icons'

import styles from './index.module.scss'
// import Image from 'next/image'
// import Router from 'next/router'
import { Input, Form, Button, Modal } from 'antd'
import { request } from '@utils'

export default function Contact({ countries }) {
  const onFinish = (r) => {
    return request({
      method: 'POST',
      url: '/api/message/add',
      data: { type: 1, ...r }
    }).then((r) => {
      if (r.code === 0) {
        Modal.success({
          title: 'Thanks for Your Message',
          content:
            'We’re thrilled to hear from you! We will get back in touch with you soon!',
          onOk() {
            window.location.reload()
          }
        })
      } else {
        Modal.error({ content: r.msg })
      }
    })
  }

  return (
    <div className={styles.main}>
      <Head>
        <title>
          Contact Y Montessori - Y Montessori, Montessori School, Montessori
          Education, Montessori
        </title>
        <meta
          name='title'
          content={`Contact Y Montessori - Y Montessori, Montessori School, Montessori Education, Montessori`}
        />
      </Head>
      <div className={styles.box}>
        <div className={styles.boxTop}>
          <div className={styles.boxTopLeft}>
            <img src='/lsa.png' alt='contact us'></img>
          </div>
          <div className={styles.boxTopRight}>
            I'm Isabella Cai, the founder of Y Montessori. As a Montessori
            mother and former data analyst, I transitioned to entrepreneurship
            out of a deep passion for Montessori education. During the pandemic,
            I homeschooled my daughters for 18 months using Montessori methods
            and later trained through the Montessori Institute of North Texas.
            This experience inspired me to start a Montessori parent group at my
            workplace, which quickly grew to over 300 members. While running
            that group, I realized how challenging it is for parents to find the
            right Montessori schools. This insight led me to combine my passion
            for Montessori and my data skills to launch Y Montessori, a platform
            that lists over 5,000 Montessori schools. Building on this success,
            we developed Montopia, an app designed to revolutionize parent
            engagement in Montessori schools by seamlessly integrating parents
            into their child's learning journey and bridging the gap between
            home and school.
          </div>
          {/* <img src="/contact-us.jpg" alt="contact us"></img> */}
        </div>
        <div className={styles.boxLeft}>
          <div className={styles.boxLeftTitle}>
            <h1>Let's Chat.</h1>
            <h2>Tell us about your thoughts!</h2>
          </div>
          <div className={styles.boxLeftBody}>
            <div className={styles.boxLeftBodyItem}>
              <div className={styles.boxLeftBodyItemLeft}>
                <PhoneOutlined style={{ fontSize: 28, color: 'white' }} />
              </div>
              <div className={styles.boxLeftBodyItemRight}>
                <p>Email us at:</p>
                <a>info@ymontessori.com</a>
              </div>
            </div>
            <div className={styles.boxLeftBodyItem}>
              <div className={styles.boxLeftBodyItemLeft}>
                <MailOutlined style={{ fontSize: 28, color: 'white' }} />
              </div>
              <div className={styles.boxLeftBodyItemRight}>
                <p>Call us at:</p>
                <a>+1(858)336-5511</a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.boxRight}>
          <h2>Send us a message</h2>
          <Form
            name='basic'
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
          >
            <Form.Item
              label=''
              name='name'
              rules={[
                { required: true, message: 'Please input your full name!' }
              ]}
            >
              <Input placeholder='* Full Name' />
            </Form.Item>

            <Form.Item
              label=''
              name='email'
              rules={[
                { required: true, message: 'Please input your email!' },
                {
                  type: 'email',
                  message: 'Please enter the correct email address!'
                }
              ]}
            >
              <Input placeholder='* Email Address' />
            </Form.Item>

            <Form.Item
              label=''
              name='subject'
              rules={[
                { required: true, message: 'Please input your subject!' }
              ]}
            >
              <Input placeholder='* Subject' />
            </Form.Item>

            <p style={{ margin: '15px 0 5px 0' }}>
              Tell us about your thoughts
            </p>
            <Form.Item label='' name='content'>
              <Input.TextArea
                rows={6}
                placeholder='Please input your content!'
              />
            </Form.Item>

            <Form.Item>
              <Button type='primary' htmlType='submit'>
                Send Message
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  )
}

// export async function getServerSideProps() {
//   const response = await fetch('https://restcountries.com/v3.1/all')
//   const countries = await response.json()

//   return {
//     props: {
//       countries: countries.map((country) => ({
//         name: country.name.common,
//         cca2: country.cca2,
//         population: country.population
//       }))
//     }
//   }
// }
